







































































import { computed, defineComponent, onMounted, toRefs, watch } from '@vue/composition-api';
import { changePowerAnimation, computeValue } from './set-power-animation';

const name = 'ttam-split-budget-power-dashboard';

export default defineComponent({
  name,

  props: {
    power: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const { power } = toRefs(props);
    const face = computed(() => computeValue(power.value, 'face'));

    onMounted(() => {
      watch(power, changePowerAnimation);
    });

    return { name, face };
  },
});
